import { Model } from "./Base.js";

export class CaminhaoModel extends Model {
    get defaults() {
        return {
            placa: "",
            ano: "",
            renavam: "",
            marca: "",
            modelo: "",
            usuario: ""
        };
    }
}